import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import AppLogo from '../../components/AppLogo'
import { getMe, logout } from '../../store/authSlice'
import { RootState, AppDispatch } from '../../store/store'
import { shellConsumerLoginUrl } from '../../utils/shellConsumerLoginUrl'
import { foodSupportWaUrl } from '../../utils/foodSupportWa'
import FoodPaymentKey from '../../components/FoodPaymentKey'
import { isFoodPendingSession } from '../../utils/foodPendingSession'
import { isFoodExpiredSession } from '../../utils/foodExpiredSession'

export default function PendingActivationPage() {
  const dispatch = useDispatch<AppDispatch>()
  const { accessToken, user, subscription, meReady } = useSelector((s: RootState) => s.auth)
  const [renewUrl, setRenewUrl] = useState(String((user as any)?.renewUrl || ''))

  useEffect(() => {
    if (!accessToken) return
    dispatch(getMe()).then((res: any) => {
      const payload = res?.payload
      const url = payload?.renewUrl || payload?.renew_url || payload?.user?.renewUrl
      if (url) setRenewUrl(String(url))
    })
  }, [accessToken, dispatch])

  const handleLogout = () => {
    dispatch(logout())
    try {
      localStorage.removeItem('d28d_shell')
      localStorage.removeItem('d28d_token')
      localStorage.removeItem('token')
      localStorage.removeItem('refreshToken')
    } catch { /* noop */ }
    window.location.assign('/login')
  }

  const handleRenew = () => {
    window.location.assign(renewUrl || shellConsumerLoginUrl())
  }

  if (!accessToken) return <Navigate to="/login" replace />
  if (!meReady) {
    return (
      <div className="food-plan-root min-h-screen grid place-items-center bg-[#f9fafb] text-gray-600 text-sm">
        Comprobando tu plan Food…
      </div>
    )
  }
  if (isFoodExpiredSession(user, subscription)) {
    return <Navigate to="/plan-vencido" replace />
  }
  if (!isFoodPendingSession(user, subscription)) {
    const role = String(user?.role || '').toUpperCase()
    const home = role === 'TRAINER' ? '/trainer' : role === 'ADMIN' ? '/admin' : role === 'SUPER_ADMIN' ? '/superadmin' : '/dashboard'
    return <Navigate to={home} replace />
  }

  return (
    <div className="food-plan-root min-h-screen bg-[#f9fafb] flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-lg border border-gray-100 p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-2xl bg-[#64ba30]/10 flex items-center justify-center">
            <AppLogo size={40} />
          </div>
        </div>
        <p className="text-xs font-semibold tracking-wide uppercase text-[#64ba30] mb-2">Food Plan</p>
        <h1 className="text-2xl font-bold text-[#111827] mb-3">Pendiente de activación</h1>
        <p className="text-gray-600 text-sm leading-relaxed mb-4">
          Tu Food Plan aún no está habilitado. Paga con Wompi o por llave. Un administrador
          confirmará la activación. Mientras tanto no puedes usar nutrición, medidas ni el resto de funciones.
        </p>
        <FoodPaymentKey />
        <div className="rounded-2xl bg-[#64ba30]/10 border border-[#64ba30]/20 px-4 py-3 text-sm text-[#166534] mb-6">
          Pendiente de activación
        </div>
        <button
          type="button"
          onClick={handleRenew}
          className="w-full py-3.5 rounded-2xl text-white text-base font-semibold bg-[#64ba30] hover:bg-[#58a52a] transition-colors mb-3"
        >
          Pagar con Wompi
        </button>
        <a
          href={foodSupportWaUrl(user)}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full py-3.5 rounded-2xl text-base font-semibold border border-gray-200 text-[#111827] hover:bg-gray-50 transition-colors mb-3"
        >
          Soporte
        </a>
        <button
          type="button"
          onClick={handleLogout}
          className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  )
}
